module.exports = __webpack_public_path__ + "Simple-Line-Icons.d2285965fe34b0546504.ttf";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/assets/fonts/Simple-Line-Icons.ttf?v=2.4.0
// module id = ../../../../../src/assets/fonts/Simple-Line-Icons.ttf?v=2.4.0
// module chunks = styles